<app-user-update [displayColumns]="displayedColumns" [userType]="userType" [route]="route"></app-user-update>